import api from './api'

const services = {
    create(data) {
        return api().post('events', data)
    },
    list(search) {
        return api().get(`events${search ? search : ''}`)
    },
    unreadCount() {
        return api().get('events/unread-count')
    },
    markRead() {
        return api().patch('events/read-all')
    },
    remove(id) {
        return api().delete(`events/${id}`)
    }
}

export default services
